import React from "react";
import styled from "styled-components";
import { Box, Text, TileLink } from "@origin-digital/ods-core";
import { IconChevronRightSmall } from "@origin-digital/ods-icons";
import type { QuickAction } from "../../services/categories/types";
import { isIconUrl, isValidHref } from "./helpers";

const IconPlaceholder = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

const IconImage = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

const resolveIconSlot = (icon: string | null | undefined): React.ReactNode => {
  if (!icon || !isIconUrl(icon)) {
    return <IconPlaceholder aria-hidden="true" />;
  }
  return <IconImage src={icon} alt="" aria-hidden="true" />;
};

const QuickListItem: React.FC<QuickAction> = ({ label, href, icon }) => {
  if (!label || !isValidHref(href)) return null;
  const dataId = `quick-list-item-${label.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <TileLink
      href={href}
      dataId={dataId}
      hideChevron
      cardProps={{
        backgroundColor: "white",
        borderRadius: "medium",
        paddingXSpecific: "medium",
        paddingYSpecific: "medium",
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap="small"
        style={{ width: "100%" }}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap="small">
          {resolveIconSlot(icon)}
          <Text tone="neutralDark">{label}</Text>
        </Box>
        <IconChevronRightSmall
          variant="solid"
          size="xxsmall"
          color="neutralDark"
        />
      </Box>
    </TileLink>
  );
};

interface QuickListItemsProps {
  quickActions: QuickAction[];
  className?: string;
}

export const QuickListItems: React.FC<QuickListItemsProps> = ({
  quickActions,
  className,
}) => (
  <div className={className} data-id="quick-list-items">
    {quickActions.map((action, index) => (
      <QuickListItem key={action.href || action.label || index} {...action} />
    ))}
  </div>
);
